import type * as React from 'react';
import { useAppMeta } from '../hooks/app.meta.hook';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

function PricingPage({ planSelect }: { planSelect?:string | null }) {
  let fpTid = undefined;
  if('FPROM' in window){
    // @ts-ignore
    fpTid = window.FPROM.data.tid;
    console.log('fpTid', fpTid);
  }
  const meta = useAppMeta();
  // Paste the stripe-pricing-table snippet in your React component
  console.log('pricing page userID', planSelect, meta?.getTableID(planSelect));
  if(!meta) return <div>Loading Stripe Price Table...</div>;
  return (
  // @ts-ignore
    <stripe-pricing-table pricing-table-id={meta.getTableID(planSelect!)}
      publishable-key={meta.stripePK}
      client-reference-id={fpTid}
    >
      {/* @ts-ignore */}
    </stripe-pricing-table>
  );
}

export default PricingPage;